import { StorageBackend } from './index'

class BrowserStorageBackend implements StorageBackend {
  constructor(private name: string) {}

  protected get storage(): Storage {
    throw new Error('not implemented')
  }

  private loadItem(): any {
    const item = this.storage.getItem(this.name)
    if (item !== null) {
      try {
        return JSON.parse(item)
      } catch (err) {
        console.error('failed to get storage item')
      }
    } else {
      return {}
    }
  }

  public get storageName(): string {
    return this.name
  }

  public set(key: string, value: any) {
    const data = this.loadItem()
    data[key] = value
    this.storage.setItem(this.name, JSON.stringify(data))
  }

  public get(key: string): any {
    return this.loadItem()[key]
  }

  public remove(key: string) {
    const data = this.loadItem()
    delete data[key]
    this.storage.setItem(this.name, JSON.stringify(data))
  }

  public clear() {
    this.storage.removeItem(this.name)
  }
}

export class LocalStorageBackend extends BrowserStorageBackend {
  public static isSupported(): boolean {
    return !!window.localStorage
  }

  protected get storage(): Storage {
    const st = window.localStorage
    if (!st) {
      throw new Error('LocalStorage not supported')
    }
    return st
  }
}

export class SessionStorageBackend extends BrowserStorageBackend {
  public static isSupported(): boolean {
    return !!window.localStorage
  }

  protected get storage(): Storage {
    const st = window.sessionStorage
    if (!st) {
      throw new Error('SessionStorage not supported')
    }
    return st
  }
}
